import parseHtmlToReact from 'html-react-parser';
import { useState, useEffect } from 'react';

import type { EditorialContent } from '@cobalt/utilities';
import PictureHelper from '@shared/PictureHelper';

export const DisciplinaryBodiesContent = ({
  content: { body, mainMedia, title, description },
}: {
  content: EditorialContent;
}) => {
  const [bodyHtml, setBodyHtml] = useState('');

  useEffect(() => {
    if (!body) return;

    const paragraphs = body.filter((bi) => bi._type === 'PARAGRAPH');
    const newBodyHtml = paragraphs.reduce((res: string, bi) => res + bi._html, '');
    setBodyHtml(newBodyHtml);
  }, [body]);

  return (
    <div className='disciplinary-cedb__card'>
      <div className='card__image'>
        <PictureHelper
          formats={['1440@s4', '960@s4', '768@s4', '440@s4', '0@s4']}
          className='card__picture'
          image={mainMedia.image}
          title={title}
        />
      </div>
      <h2 className='card__title'>{title}</h2>
      <h2 className='card__country'>{description}</h2>
      <div className='card__body'>{parseHtmlToReact(bodyHtml ?? '')}</div>
    </div>
  );
};

export default DisciplinaryBodiesContent;
